import React from "react";

const SvgArrowNext = (props) => (
  <svg width="17" height="14" viewBox="0 0 17 14" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.166645 7.00016C0.166645 6.53993 0.560469 6.16683 1.04628 6.16683H15.1204C15.6062 6.16683 16 6.53993 16 7.00016C16 7.4604 15.6062 7.8335 15.1204 7.8335H1.04628C0.560469 7.8335 0.166645 7.4604 0.166645 7.00016Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.55601 13.3828C9.24283 13.0231 9.26234 12.4607 9.59958 12.1266L14.7753 6.99974L9.59963 1.87379C9.26236 1.53975 9.24281 0.977327 9.55596 0.61757C9.86912 0.257814 10.3964 0.23696 10.7337 0.570991L16.567 6.34829C16.7368 6.51647 16.8333 6.75247 16.8333 6.99965C16.8333 7.24682 16.7368 7.48283 16.567 7.65103L10.7337 13.4293C10.3965 13.7633 9.86919 13.7425 9.55601 13.3828Z"
      fill="white"
    />
  </svg>
);
export default SvgArrowNext;
